<template>
  <div class="group-detail">
    <h1 class="common__main-title">Tutor Contract Details</h1>
    <div class="common__sub-title">
      <span>Details</span>
    </div>
    <div class="common__main-contener">
        <form class="pb-5">

          <div class="form-group">
            <label>Residence status</label>
            <div>{{ passport && passport.status }}</div>
          </div>
          <div class="form-group">
            <label>Passport number</label>
            <div>{{ passport && passport.number }}</div>
          </div>
          <div class="form-group">
            <label>Passport validity period</label>
            <div>
              {{ passport && passport.from.format('YYYY/MM/DD') }}
              〜
              {{ passport && passport.to && passport.to.format('YYYY/MM/DD') }}
            </div>
          </div>
          <div class="form-group">
            <label>Residence card</label>
            <div>{{ passport && passport.residence.card }}</div>
          </div>
          <div class="form-group">
            <label>Residence validity period</label>
            <div>
              {{ passport && passport.residence.from.format('YYYY/MM/DD') }}
              〜
              {{ passport && passport.residence.to && passport.residence.to.format('YYYY/MM/DD') }}
            </div>
          </div>
          <div class="form-group">
            <label>Contract period</label>
            <div>
              {{ contract.from && contract.from.format('YYYY/MM/DD') }}
              〜
              {{ contract.to && contract.to.format('YYYY/MM/DD') }}
            </div>
          </div>
          <div class="form-group">
            <label>Position</label>
            <div>
              {{ contract.position && contract.position.name }}
              ( {{ contract.isFixedTerm && contract.isFixedTerm ? 'Fixed' : 'Indefinite' }}-term )
            </div>
          </div>
          <div class="form-group">
            <label>Monthly Salary, Hourly Wage</label>
            <div>
              {{ contract.salary && contract.salary.fixed }} yen,
              {{ contract.salary && contract.salary.hourly }} yen /hour
            </div>
          </div>
          <div class="form-group">
            <label>Lessons</label>
            <div>
              {{ contract && contract.numberOf.lessonsForWeek }} /week,
              {{ contract && contract.numberOf.lessonsForMonth }} /month
            </div>
          </div>
          <div class="form-group">
            <label>Regular Waitings per Week, Last Waitings per Week</label>
            <div>
              {{ contract && contract.numberOf.waitingsForWeek }} /week,
              {{ contract && contract.numberOf.lastWaitingsForWeek }} /week
            </div>
          </div>
          <div class="form-group">
            <label>Review sheet</label>
            <div>{{ contract.reviewSheet }}</div>
          </div>
          <div class="form-group">
            <label>TE Sub Fee, WTE Sub Fee</label>
            <div>
              {{ contract.salary && contract.salary.teSubstituteLesson }} yen,
              {{ contract.salary && contract.salary.wteSubstituteLesson }} yen
            </div>
          </div>
          <div class="form-group">
            <label>Deduction for WTE Absence</label>
            <div>{{ contract.salary && contract.salary.wteOneFrameAbsenteeism }} yen</div>
          </div>
          <div class="form-group">
            <label>10 Minutes Sub Fee</label>
            <div>{{ contract.salary && contract.salary.substituteForTenMinutes }} yen</div>
          </div>
          <div class="form-group">
            <label>Allotted Annual Leave</label>
            <div>
              {{ contract.vacation && contract.vacation.plannedGrants }} days
            </div>
          </div>
          <div class="form-group">
            <label>Remaining Paid Absence Days / Total Paid Absence Days</label>
            <div>
              {{ contract.vacation && contract.vacation.remainingHolidays }} days
              /{{ contract.vacation && contract.vacation.plannedHolidays }} days
            </div>
          </div>
          <div
            class="form-group contract-box"
            v-for="(additionalcontract, index) in contract.additionalContracts" :key="index"
          >
            <h4>Additional Contract {{ index + 1 }}</h4>
            <div class="detail-text">
              <span class="sub-text">hourly wage：</span>
              {{ additionalcontract.hourly}} yen /hour
            </div>
            <div class="detail-text">
              <span class="sub-text">fixed salary：</span>
              {{ additionalcontract.fixed}} yen
            </div>
            <div class="detail-text">
              <span class="sub-text">work quantity：</span>
              {{ additionalcontract.workQuantity}}
            </div>
          </div>

        </form>

        <div class="d-flex justify-content-between">
          <b-button pill variant="secondary" @click="$router.go(-1)">
            Back
          </b-button>
        </div>
    </div>
    <loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import { Contract, Passport, Tutor } from '@/store/tutors/types'
import Loading from '@/components/parts/modal/Loading.vue'

export default Vue.extend({
  components: {
    Loading,
  },

  data: (): {
    isLoading: boolean
  } => ({
    isLoading: false,
  }),

  computed: {
    tutor(): Tutor|undefined {
      return this.$store.getters.findTutorById(this.$route?.params?.tutorId)
    },
    contract(): Contract|undefined {
      return _.find(this.tutor?.contracts, { contractNumber: this.$route?.params?.contractId })
    },
    passport(): Passport|undefined {
      return _.get(this.contract, 'passport')
    },
  },

  created() {
    this.isLoading = true
    this.$store.dispatch('getTutor', { tutorId: this.$route.params.tutorId })
      .finally(() => { this.isLoading = false })
  },
})
</script>

<style scoped>

.button-container {
  display: flex;
  justify-content: space-between;
}

.contract-box {
  margin-top: 30px;
}

.sub-text {
  color: #000;
}

.detail-text {
  margin-bottom:10px;
}

</style>
